import type { AxiosInstance } from 'axios';
import { DASHBOARD_CONFIG } from '@/config/dashboard';
import type { GlobalStudentRanking } from '../../domain/entities/global-student-ranking.entity';
import type { GlobalClassVSGeneral } from '../../domain/entities/global-class-vs-general.entity';
import type { GlobalStudentVSGeneral } from '../../domain/entities/global-student-vs-general.entity';

export class GlobalDashboardApiDatasource {
  private readonly client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async getGlobalStudentRanking(
    page: number,
    pageSize: number,
  ): Promise<GlobalStudentRanking> {
    const { data } = await this.client.get<
      GlobalStudentRanking | { report: GlobalStudentRanking }
    >('v1/mockexamperformancedashboard/overview/student-ranking', {
      params: { page, pageSize, courseId: DASHBOARD_CONFIG.courseId },
    });

    return 'report' in data ? data.report : data;
  }

  async getClassVSGeneral(
    institution?: string,
    courseId?: string,
  ): Promise<GlobalClassVSGeneral> {
    const { data } = await this.client.get<
      GlobalClassVSGeneral | { report: GlobalClassVSGeneral }
    >('v1/mockexamperformancedashboard/overview/class-vs-general', {
      params: {
        institution,
        courseId: courseId ?? DASHBOARD_CONFIG.courseId,
      },
    });

    return 'report' in data ? data.report : data;
  }

  async getStudentVSGeneral(email: string): Promise<GlobalStudentVSGeneral> {
    const { data } = await this.client.get<
      GlobalStudentVSGeneral | { report: GlobalStudentVSGeneral }
    >('v1/mockexamperformancedashboard/overview/student-vs-general', {
      params: { email, courseId: DASHBOARD_CONFIG.courseId },
    });

    return 'report' in data ? data.report : data;
  }
}
